import React, {Fragment, useState, useEffect, useContext} from 'react'
import './OrderSummary.css'
import CustomerInfo from './CustomerInfo'
import TotalPriceInfo from './TotalPriceInfo'
import PanelTable from './tables/PanelTable'
import FixingsTable from './tables/FixingsTable'
import FlashingsTable from './tables/FlashingsTable'
import BeamsTable from './tables/BeamsTable'
import PostsTable from './tables/PostsTable'
import RainwaterTable from './tables/RainwaterTable'
import LightsTable from './tables/LightsTable'
import {moneyFormatter} from '../../../../utils'
import MiscTable from './tables/MiscTable'
import {QuickOrderContext} from '../../../context/QuickOrderContext'
import {Link, useHistory} from 'react-router-dom'
import PaymentMethod from './PaymentMethod'
import {ICustomerOrder} from '../../../models/quick-order/customerOrder'
import axios from 'axios'
import {getPostcodeMatriceByPostcode} from '../../../api'
import AccessoriesTable from './tables/AccessoriesTable'
import ForkliftPromptModal from '../../../../_metronic/partials/modals/ForkliftPromptModal'
import LoginPromptModal from '../../../../_metronic/partials/modals/LoginPromptModal'
import { getCustomerDetailsByEmail } from '../../../api/customerdetails-api'
import { 
  ORDER_SUMMARY_SECTION_PANELS,
  ORDER_SUMMARY_SECTION_FIXINGS,
  ORDER_SUMMARY_SECTION_FLASHINGS,
  ORDER_SUMMARY_SECTION_RAINWATERGOODS,
  ORDER_SUMMARY_SECTION_BEAMS,
  ORDER_SUMMARY_SECTION_POSTS,
  ORDER_SUMMARY_SECTION_LIGHTS,
  ORDER_SUMMARY_SECTION_ACCESSORIES,
  PRICEBOOK_SYDNEY,
  PRICEBOOK_NORTH
} from '../../../common/constant'

type OrderSummaryContentProps = {
  isCustomerPortal?: boolean
  email?: string
}

function OrderSummaryContent({ isCustomerPortal = false, email }: OrderSummaryContentProps) {
  const history = useHistory()
  const baseURL = process.env.REACT_APP_API_URL
  const {cartItemsWithGST, cartItems, getComputeSummaryTotal} = useContext(QuickOrderContext)

  if (cartItems.length === 0) {
    window.location.href = isCustomerPortal ? '/customer/quick-order' : '/quick-order'
  }

  const [customer] = useState<any>(() => {
    const raw = localStorage.getItem('customer-info')
    const parsed = raw ? JSON.parse(raw) : {}
    return {
      firstName: parsed.firstName ?? '',
      lastName: parsed.lastName ?? '',
      companyName: parsed.companyName ?? '',
      contact: parsed.contact ?? '',
      email: parsed.email ?? '',
      address1: parsed.address1 ?? '',
      address2: parsed.address2 ?? '',
      suburb: parsed.suburb ?? '',
      state: parsed.state ?? '',
      postCode: parsed.postCode ?? '',
      country: parsed.country ?? 'Australia',
    }
  })
  const [summaryTotalPrice] = useState(JSON.parse(localStorage.getItem('summaryTotalPrice') as any) || {})

  const [shippingPreference] = useState(
    JSON.parse(localStorage.getItem('shipping-preference') as any)
  )
  const [selectedPaymentMethod] = useState(localStorage.getItem('paymentMethod') || '')
  const [totalPrice] = useState(JSON.parse(localStorage.getItem('totalPrice') as any))
  const [customerOrder, setCustomerOrder] = useState<ICustomerOrder>()
  const isDelivery = shippingPreference.shipping === 'delivery'
  const [isServiceable, setIsServiceable] = useState(false)

  const [requiresForklift, setRequiresForklift] = useState<boolean | null>(null)
  const [forkliftModalOpen, setForkliftModalOpen] = useState(false)
  const [pendingForkliftOpen, setPendingForkliftOpen] = useState(false)
  const [detectedRegion, setDetectedRegion] = useState<string>('')

  const [showLoginPrompt, setShowLoginPrompt] = useState(false)
  const [promptEmail, setPromptEmail] = useState<string | undefined>(undefined)

  const tenth = 0.1
  const totalGST = totalPrice * tenth

  useEffect(() => {
    if (!isCustomerPortal) {
      localStorage.setItem('postLoginRedirect', '/customer/quick-order/order-summary')
    }
  }, [isCustomerPortal])


  useEffect(() => {
    if (isDelivery) {
      if (customer.postCode && customer.postCode.length === 4) {
        const fetchData = async () => {
          try {
            const postCodeMatrix: any = await getPostcodeMatriceByPostcode(customer.postCode)
            if (postCodeMatrix.data && postCodeMatrix.data.pricebookId !== null) {
              setIsServiceable(true)
            }
          } catch (ex) {}
        }

        // fetchData()
        setIsServiceable(true)
      }
    } else {
      setIsServiceable(true)
    }
  }, [customer.postCode])

  useEffect(() => {
    if (isCustomerPortal) return

    const stored = localStorage.getItem('customer-info')
    if (!stored) return

    try {
      const parsed = JSON.parse(stored) || {}
      const email: string | undefined = parsed?.email?.trim()
      if (!email) return

      setPromptEmail(email)

      const fetchCustomerDetails = async () => {
        await new Promise((r) => setTimeout(r, 500))
        try {
          const data: any = await getCustomerDetailsByEmail(email)
          if (data && (data.emailAddress || data.firstName || data.lastName)) {
            setShowLoginPrompt(true)
          }
        } catch (err) {
          console.error('Failed to fetch customer details:', err)
        }
      }
      fetchCustomerDetails()
    } catch (err) {
      console.error('Failed to parse customer-info from localStorage:', err)
    }
  }, [isCustomerPortal])

  useEffect(() => {
    if (isDelivery) {
      const stored = localStorage.getItem('customer-info')
      if (!stored) return

      const parsed = JSON.parse(stored) || {}
      const pc: string | undefined = parsed?.postCode?.trim()
      if (!pc) return

      if (!pc || `${pc}`.length !== 4) return

      const fetchPostcodeMatrix = async () => {
        await new Promise((r) => setTimeout(r, 500))
        try {
          const res: any = await getPostcodeMatriceByPostcode(pc)
          const pbName = res?.data?.pricebook

          if (pbName === PRICEBOOK_SYDNEY) {
            setDetectedRegion('Sydney & Surrounds')

            if (isCustomerPortal) {
              setForkliftModalOpen(true)
              setPendingForkliftOpen(false)
            } else {
              setPendingForkliftOpen(true)
            }
          } else if (pbName === PRICEBOOK_NORTH) {
            setDetectedRegion('North Queensland')

            if (isCustomerPortal) {
              setForkliftModalOpen(true)
              setPendingForkliftOpen(false)
            } else {
              setPendingForkliftOpen(true)
            }
          }
        } catch (error) {
          console.error('Failed to fetch postcode matrix:', error)
        }
      };

      fetchPostcodeMatrix()
    }
  }, [isDelivery, isCustomerPortal])

  const handleConfirmLogin = () => {
    history.push(`/login`)
  }

  const handleCancelLogin = () => {
    setShowLoginPrompt(false)
    if (pendingForkliftOpen) {
      setForkliftModalOpen(true)
      setPendingForkliftOpen(false)
    }
  }

  const handleForkliftYes = () => {
    setRequiresForklift(true)
    setForkliftModalOpen(false)
    localStorage.setItem('requiresForklift', 'true')
  }
  const handleForkliftNo = () => {
    setRequiresForklift(false)
    setForkliftModalOpen(false)
    localStorage.setItem('requiresForklift', 'false')
  }

  const saveCustomerOrder = async () => {
    try {
      const payload = customerOrder
        ? {
            ...customerOrder,
            orderSummary: {
              ...customerOrder.orderSummary,
              requiresForklift: requiresForklift,
            },
          }
        : undefined
      
      const response = await axios.post(`${baseURL}/Customer/Order`, payload)
      let orderNumber = parseInt(response.data)
      if (!isNaN(orderNumber) && orderNumber > 0) {
        localStorage.setItem('orderNumber', orderNumber.toString())
        localStorage.setItem('customerOrder', JSON.stringify(cartItemsWithGST))
        window.location.href = isCustomerPortal ? '/customer/quick-order/confirm-order' : '/confirm-order'
      } else {
      }
    } catch (ex) {
      console.error('Error fetching data:', ex)
    }
  }

  useEffect(() => {
    const {
      productTotalFee,
      totalGST,
      miscFee,
      totalProductAmount,
      creditcardFee,
      creditcardmiscFee,
      totalAmount,
    } = getComputeSummaryTotal()

    const formatDeliveryFee = (fee: any) => {
      if (typeof fee === 'number') {
        return fee.toFixed(2)
      }

      return fee
    }

    const formatMiscFee = (fee: any) => {
      if (typeof fee === 'string') {
        return parseFloat(fee.replace("$", "").trim())
      } else if (typeof fee === 'number') {
        return fee
      }

      return 0
    }

    console.log('cartItems', cartItems)
    setCustomerOrder({
      customer: {
        firstName: customer.firstName,
        lastName: customer.lastName,
        companyName: customer.companyName,
        contactNumber: customer.contact,
        emailAddress: customer.email,
        address: customer.address1,
        address2: customer.address2,
        suburb: customer.suburb,
        state: customer.state,
        postcode: customer.postCode,
        country: customer.country,
      },
      orderSummary: {
        customerId: 0,
        deliveryPreference: shippingPreference.shipping,
        deliveryFee: formatDeliveryFee(shippingPreference.deliveryFee),
        productTotalFee: productTotalFee,
        totalGST,
        miscFee: formatMiscFee(miscFee),
        totalProductAmount: totalProductAmount,
        creditcardFee,
        creditcardmiscFee,
        totalAmount,
        paymentMethod: selectedPaymentMethod,
        pricebookId: shippingPreference.pricebookId,
        requiresForklift: JSON.parse(localStorage.getItem('requiresForklift') || 'null')
      },
      panelOrders: cartItems
        .filter((item: any) => item.type == 'panel')
        .map((item: any) => ({
          panelPricingId: item.pricingId,
          panelDirectionalLayId: parseInt(item.directionalLayId),
          panelCutbackId: parseInt(item.cutback),
          length: item.length,
          transactedUnitPrice: item.unitPrice,
          quantity: item.quantity,
          colourId: item.topSheetColor,
          type: item.type
        })),
      fixingOrders: cartItems
        .filter((item: any) => item.type == 'fixing')
        .map((item: any) => ({
          fixingPricingId: item.pricingId,
          quantity: item.quantity,
          transactedUnitPrice: item.unitPrice,
          type: item.type
        })),
      flashingOrders: cartItems
        .filter((item: any) => item.type == 'flashing')
        .map((item: any) => ({
          flashingPricingId: item.pricingId,
          length: item.length,
          quantity: item.quantity,
          colourId: item.color,
          transactedUnitPrice: item.unitPrice,
          type: item.type,
        })),
      rainwaterOrders: cartItems.map((item: any) => {
        const length = item.type === 'gutter' ?
          (item?.rainwaterPricing?.rainwaterPart?.name.toLowerCase().includes("stop end") || item?.rainwaterPricing?.rainwaterPart?.name.toLowerCase().includes("bracket") ? 0 : item.length) :
          item.type === 'stop-end-bracket' ? 0 :
          item.length

        const colourId = (item.type === 'gutter' || 
                  ["Gutter Stop End", "Gutter Mitre Internal", "Gutter Mitre External"].includes(item.rainwaterPartName)) 
                  ? item.color 
                  : undefined
                  
        return {
          rainwaterPricingId: item.pricingId,
          length: length,
          unitQuantity: item.quantity,
          transactedUnitPrice: item.unitPrice,
          colourId: colourId,
          type: item.type,
        }
      }).filter((item: any) => ['gutter', 'stop-end-bracket'].includes(item.type)),
      beamOrders: cartItems
        .filter((item: any) => item.type == 'beam')
        .map((item: any) => ({
          beamPricingId: item.beamProductMastersId,
          colourId: item.colorId,
          length: item.length ? item.length : 0,
          quantity: item.quantity,
          transactedUnitPrice: item.unitPrice,
          type: item.type,
        })),
      postOrders: cartItems
        .filter((item: any) => item.type === 'post-item' || item.type === 'post-kit' || item.type === 'post-extendabracket')
        .map((item: any) => ({
          postPricingId: item.postProductMastersId,
          colourId: item.colorId,
          length: item.length,
          quantity: item.quantity,
          transactedUnitPrice: item.unitPrice,
          type: item.type,
        })),
      lightOrders: cartItems
        .filter((item: any) => item.type == 'lights')
        .map((item: any) => ({
          lightPricingId: item.lightProductMastersId,
          quantity: item.quantity,
          length: item.length,
          transactedUnitPrice: item.unitPrice,
          type: item.type,
        })),
        accessoryOrders: cartItems
        .filter((item: any) => item.type == 'accessory')
        .map((item: any) => ({
          accessoryPricingId: item.pricingId,
          unitQuantity: item.quantity,
          length: item.length,
          transactedUnitPrice: item.unitPrice,
          colourId: item.color,
          type: item.type,
        })),
    })
  }, [customer, requiresForklift])

  const whole = 1.0

  // PANEL SUBTOTAL PRICE
  const panelSubTotalPrice = cartItemsWithGST
    ?.filter((item: any) => item.type === 'panel')
    ?.reduce((acc: any, item: any) => {
      return acc + (item.unitPrice * item.quantity * item.length) / 1000 + item.gst
    }, 0)

  // FIXING SUBTOTAL PRICE
  const fixingSubTotalPrice = cartItemsWithGST
    ?.filter((item: any) => item.type === 'fixing')
    ?.reduce((acc: any, item: any) => {
      return (
        acc +
        (item?.fixingName === 'Tek Screws' || item?.fixingName === 'Rivets'
          ? (item.price * item.quantity) / 100
          : item.price * item.quantity) +
        item.gst
      )
    }, 0)

  // FLASHING SUBTOTAL PRICE
  const flashingSubTotalPrice = cartItemsWithGST
    ?.filter((item: any) => item.type === 'flashing')
    ?.reduce((acc: any, item: any) => {
      return acc + (item.unitPrice * item.quantity * item.length) / 1000 + item.gst
    }, 0)

  // BEAM SUBTOTAL PRICE
  const beamSubTotalPrice = cartItemsWithGST
    ?.filter((item: any) => item.type === 'beam')
    ?.reduce((acc: any, item: any) => {
      return acc + (item.unitPrice * item.quantity * item.length) / 1000 + item.gst
    }, 0)

  // POST SUBTOTAL PRICE
  const postSubTotalPrice = cartItemsWithGST
    ?.filter(
      (item: any) =>
        item.type === 'post-item' || item.type === 'post-extendabracket' || item.type === 'post-kit'
    )
    ?.reduce((acc: any, item: any) => {
      let computedPrice
      switch (item.type) {
        case 'post-kit':
          computedPrice = item.unitPrice * item.quantity + item.gst
          break
        case 'post-extendabracket':
          computedPrice = item.unitPrice * item.quantity + item.gst
          break
        case 'post-item':
          computedPrice = item.unitPrice * item.quantity + item.gst
          break
      }
      return acc + computedPrice
    }, 0)

  // RAINWATER SUBTOTAL PRICE
  const rainwaterSubTotalPrice = cartItemsWithGST
    ?.filter(
      (item: any) => item.type === 'gutter' || item.type === 'stop-end-bracket')
    ?.reduce((acc: any, item: any) => {
      let computedPrice = 0.0
      switch (item.type.toLowerCase()) {
        case 'gutter':
          computedPrice = (item.price * item.quantity * item.length) / 1000 + item.gst
          break
        case 'stop-end-bracket':
          computedPrice = item.price * item.quantity + item.gst
          break
      }
      return acc + computedPrice
    }, 0)

  // LIGHTS SUBTOTAL PRICE
  const lightsSubTotalPrice = cartItemsWithGST
    ?.filter((item: any) => item.type === 'lights')
    ?.reduce((acc: any, item: any) => {
      let computedPrice = item.unitPrice * (item.quantity === 0 ? 1 : item.quantity) + item.gst
      return acc + computedPrice
    }, 0)

  // ACESSORY SUBTOTAL PRICE
  const accessorySubTotalPrice = cartItemsWithGST
  ?.filter((item: any) => item.type === 'accessory')
  ?.reduce((acc: any, item: any) => {
    let computedPrice = 0.0
    if (item.lengthFactor > 1) {
      computedPrice = (item.unitPrice * item.length * whole) / item.lengthFactor + item.gst
    } else {
      computedPrice = item.unitPrice * item.quantity + item.gst
    }
    return acc + computedPrice
  }, 0)

  return (
    <>
      {cartItems.length === 0 ? (
        (window.location.href = isCustomerPortal ? '/customer/quick-order' : '/quick-order')
      ) : (
        <Fragment>
          <div style={{backgroundColor: 'rgb(204, 204, 204)'}} className='p-4 mb-5'>
            <h3 className='mb-0'>ORDER CHECKOUT</h3>
          </div>
          <div className='container'>
            <LoginPromptModal
              isOpen={showLoginPrompt}
              onConfirm={handleConfirmLogin}
              onCancel={handleCancelLogin}
              email={promptEmail}
            />
            <ForkliftPromptModal
              open={forkliftModalOpen}
              region={detectedRegion}
              onYes={handleForkliftYes}
              onNo={handleForkliftNo}
            />
            <div className='row mb-4'>
              <div className='d-flex'>
                <div className='p-2 flex-grow-1'>
                  <h3>ORDER SUMMARY</h3>
                </div>
                <Link to={isCustomerPortal ? '/customer/quick-order/checkout' : '/checkout'} className='btn btn-secondary me-2'>
                  Back
                </Link>
                <button
                  className='btn btn-primary'
                  onClick={() => {
                    saveCustomerOrder()
                  }}
                  disabled={isServiceable !== true || forkliftModalOpen || showLoginPrompt}
                >
                  Confirm Order
                </button>
              </div>
            </div>
            {/* SUMMARY */}
            <div className='row mb-4'>
              <CustomerInfo customer={customer} />
              <div className='col-md-2' />
              <TotalPriceInfo shippingPreference={shippingPreference} />
            </div>
            {/* PAYMENT METOD */}
            <div className='row mb-4' style={{ display: 'none' }}>
              <PaymentMethod />
            </div>
            {/* TABLES */}
            {panelSubTotalPrice > 0 && (
              <div className='row mb-4 d-flex flex-col'>
                <p className='fw-bolder text-dark' style={{fontSize: '1.05rem'}}>
                  {ORDER_SUMMARY_SECTION_PANELS}
                </p>
                <PanelTable cartItems={cartItemsWithGST} />
                <p className='d-none fw-bolder text-dark text-end' style={{fontSize: '1.05rem'}}>
                  SUBTOTAL: {moneyFormatter.format(panelSubTotalPrice)}
                </p>
              </div>
            )}
            {fixingSubTotalPrice > 0 && (
              <div className='row mb-4'>
                <p className='fw-bolder text-dark' style={{fontSize: '1.05rem'}}>
                  {ORDER_SUMMARY_SECTION_FIXINGS}
                </p>
                <FixingsTable cartItems={cartItemsWithGST} />
                <p className='d-none fw-bolder text-dark text-end' style={{fontSize: '1.05rem'}}>
                  SUBTOTAL: {moneyFormatter.format(fixingSubTotalPrice)}
                </p>
              </div>
            )}
            {flashingSubTotalPrice > 0 && (
              <div className='row mb-4'>
                <p className='fw-bolder text-dark' style={{fontSize: '1.05rem'}}>
                  {ORDER_SUMMARY_SECTION_FLASHINGS}
                </p>
                <FlashingsTable cartItems={cartItemsWithGST} />
                <p className='d-none fw-bolder text-dark text-end' style={{fontSize: '1.05rem'}}>
                  SUBTOTAL: {moneyFormatter.format(flashingSubTotalPrice)}
                </p>
              </div>
            )}
            {rainwaterSubTotalPrice > 0 && (
              <div className='row mb-4'>
                <p className='fw-bolder text-dark' style={{fontSize: '1.05rem'}}>
                  {ORDER_SUMMARY_SECTION_RAINWATERGOODS}
                </p>
                <RainwaterTable cartItems={cartItemsWithGST} />
                <p className='d-none fw-bolder text-dark text-end' style={{fontSize: '1.05rem'}}>
                  SUBTOTAL: {moneyFormatter.format(rainwaterSubTotalPrice)}
                </p>
              </div>
            )}
            {beamSubTotalPrice > 0 && (
              <div className='row mb-4'>
                <p className='fw-bolder text-dark' style={{fontSize: '1.05rem'}}>
                  {ORDER_SUMMARY_SECTION_BEAMS}
                </p>
                <BeamsTable cartItems={cartItemsWithGST} />
                <p className='d-none fw-bolder text-dark text-end' style={{fontSize: '1.05rem'}}>
                  SUBTOTAL: {moneyFormatter.format(beamSubTotalPrice)}
                </p>
              </div>
            )}
            {postSubTotalPrice > 0 && (
              <div className='row mb-4'>
                <p className='fw-bolder text-dark' style={{fontSize: '1.05rem'}}>
                  {ORDER_SUMMARY_SECTION_POSTS}
                </p>
                <PostsTable cartItems={cartItemsWithGST} />
                <p className='d-none fw-bolder text-dark text-end' style={{fontSize: '1.05rem'}}>
                  SUBTOTAL: {moneyFormatter.format(postSubTotalPrice)}
                </p>
              </div>
            )}
            {accessorySubTotalPrice > 0 && (
              <div className='row mb-4'>
                <p className='fw-bolder text-dark' style={{fontSize: '1.05rem'}}>
                  {ORDER_SUMMARY_SECTION_ACCESSORIES}
                </p>
                <AccessoriesTable cartItems={cartItemsWithGST} />
                <p className='d-none fw-bolder text-dark text-end' style={{fontSize: '1.05rem'}}>
                  SUBTOTAL: {moneyFormatter.format(accessorySubTotalPrice)}
                </p>
              </div>
            )}
            {lightsSubTotalPrice > 0 && (
              <div className='row mb-4'>
                <p className='fw-bolder text-dark' style={{fontSize: '1.05rem'}}>
                  {ORDER_SUMMARY_SECTION_LIGHTS}
                </p>
                <LightsTable cartItems={cartItemsWithGST} />
                <p className='d-none fw-bolder text-dark text-end' style={{fontSize: '1.05rem'}}>
                  SUBTOTAL: {moneyFormatter.format(lightsSubTotalPrice)}
                </p>
              </div>
            )}
            {shippingPreference?.shipping === 'delivery' && (
              <div className='row mb-4'>
                <p className='fw-bolder text-dark' style={{fontSize: '1.05rem'}}>
                  Miscellaneous
                </p>
                <MiscTable shippingPreference={shippingPreference} />
              </div>
            )}
          </div>
        </Fragment>
      )}
    </>
  )
}

export default OrderSummaryContent
